import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles, rem } from '@mantine/core'

export default createStyles(
  (_theme, { starterAvatarSize }: { starterAvatarSize: number }) => {
    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(16),
        justifyContent: 'center',
        height: '100%',
      },
      heading: { color: '#fff' },
      description: { color: '#fff' },
      icon: {
        flexShrink: 0,
      },
      header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: rem(8),
      },
      mainInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(12),
        height: '100%',
        justifyContent: 'center',
      },
      avatarWrapper: {
        width: rem(starterAvatarSize),
      },
      frame: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        backgroundImage: `url(${CommonGAssets.getAssetPath(
          'soya/avatar-frame.png',
        )})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      },
      avatar: {
        position: 'absolute',
        top: '14%',
      },
      avatarRoot: {
        width: `${0.75 * starterAvatarSize}px`,
        height: `${0.75 * starterAvatarSize}px`,
        minWidth: `${0.75 * starterAvatarSize}px`,
        backgroundImage:
          'linear-gradient(90deg, #F8EABF 0%, #F7DA92 50.25%, #F2CA67 100%)',
      },
      suggestContent: {
        textAlign: 'center',
      },
      suggestListing: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(12),
        flexShrink: 0,
        paddingBottom: rem(16),
      },
      action: {},
      welcomeText: {
        textAlign: 'center',
        maxWidth: rem(520),
      },
      scrollBody: {},
    }
  },
)
